import { useEffect, useRef, useState } from 'react';

export function useDidMount(fn) {
    const isFnCalled = useRef(false);

    useEffect(() => {
        !isFnCalled.current && fn();
        isFnCalled.current = true;
    }, [fn])
}

export function useStateWithCallback(initialValue) {
    const callbackRef = useRef(null);

    const [value, setValue] = useState(initialValue);

    useEffect(() => {
        if (callbackRef.current) {
            callbackRef.current(value);

            callbackRef.current = null;
        }
    }, [value]);

    const setValueWithCallback = (newValue, callback) => {
        callbackRef.current = callback;

        return setValue(newValue);
    };

    return [value, setValueWithCallback];
}
